
import React from 'react';

const ContactInfoPopup = () => {
  return (
    <div
      className="absolute"
      style={{
        width: '210px',
        height: 'auto',
        top: '60px',
        right: '0px',
        padding: '8px 12px',
        gap: '2px',
        borderRadius: '10px',
        border: '1px solid #ccc',
        backgroundColor: 'white',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        zIndex: 102,
        marginRight: '8px'
      }}
    >
      <div style={{
        width: '100%',
        height: 'auto',
        gap: '0px',
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '-0.3px',
        textAlign: 'left',
        marginBottom: '8px',
        color: '#000000'
      }}>
        Contact Support
      </div>
      <div style={{
        width: '100%',
        height: 'auto',
        gap: '4px',
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px',
        letterSpacing: '-0.2px',
        color: '#000000'
      }}>
        <div className="flex items-center gap-2 mb-2">
          <img
            src="https://img.icons8.com/material-outlined/24/0000FF/email-open.png"
            alt="email icon"
            className="w-4 h-4"
          />
          <p style={{ margin: '0', color: '#5F5F6A' }}>Interview@prompthire.ai</p>
        </div>
        <div className="flex items-center gap-2">
          <img
            src="https://img.icons8.com/material-outlined/24/0000FF/phone.png"
            alt="phone icon"
            className="w-4 h-4"
          />
          <p style={{ margin: '0', color: '#5F5F6A' }}>(+91)79790 23221</p>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoPopup;